import styled from 'styled-components';
import { colors } from '@dexma/ui-components';

const loadingSize = '0.6em';

export const StyledLoading = styled.div`
    position: absolute;
    left: 50%;
    z-index: 2;
    top: 50%;
    padding: 0.1em 0.5em;
    transform: translate(-50%, -50%);
    background-color: ${colors.gray100};
    display: flex;

    span {
        padding-left: 8px;
        font-size: ${loadingSize};
        color: ${colors.gray600};
        font-weight: 600;
        line-height: 22px;
    }
`;
